/*
 * @Description: 埋点
 * @Author: Xiaochun liu
 * @Date: 2023-08-21 15:10:42
 * @LastEditors: Xiaochun liu
 * @LastEditTime: 2023-08-31 09:53:18
 */
// ./plugins/posthog.js
import posthog from 'posthog-js'

export default {
  install(app: any) {
    const VITE_APP_POSTHOG_KEY = import.meta.env.VITE_APP_POSTHOG_KEY as string
    const VITE_APP_POSTHOG_URL = import.meta.env.VITE_APP_POSTHOG_URL as string
    app.config.globalProperties.$posthog = posthog.init(
      VITE_APP_POSTHOG_KEY,
      {
        api_host: VITE_APP_POSTHOG_URL,
        autocapture: true,
      },
    )
    const $posthog = app.config.globalProperties.$posthog
    window.$posthog = $posthog
    // 生产环境关闭调试模式
    if (import.meta.env.VITE_APP_POSTHOG_CONSOLE === 'true') {
      // 开启调试模式
      $posthog.debug()
    }
    // 注册全局字段
    $posthog.register({
      system: 'CoWork', // 子系统
      platform: '美业颜究院', // 平台
    })
  },
}
